export default "__VITE_ASSET__zVDYEySz__"